interface ToggleSwitchProps {
  isEnabled: boolean;
  isToggled: boolean;
  setIsToggled: React.Dispatch<React.SetStateAction<boolean>>;
}

function ToggleSwitch({
  isEnabled,
  isToggled,
  setIsToggled,
}: ToggleSwitchProps) {
  const handleToggle = () => {
    if (!isEnabled) return;
    setIsToggled(!isToggled);
  };

  return (
    <div
      className={`w-10 h-6 rounded-full flex items-center px-1 transition-all duration-300 ${
        isToggled ? "bg-sangati-green" : "bg-[#A3A3A3]"
      } ${isEnabled ? "cursor-pointer" : "opacity-50 cursor-not-allowed"}`}
      onClick={handleToggle}
    >
      <div
        className={`w-4 h-4 bg-white rounded-full transform transition-transform duration-300 ${
          isToggled ? "translate-x-4" : "translate-x-0"
        }`}
      ></div>
    </div>
  );
}

export default ToggleSwitch;
